import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.offsetTop = 0;
    window.addEventListener("resize", this.onResize.bind(this));

    this.onResize();
  }

  onResize() {
    if (
      this.element.offsetHeight < window.innerHeight - 256 &&
      window.innerWidth >= 992
    ) {
      this.offsetTop = (window.innerHeight - this.element.offsetHeight) / 2;
      this.stick();
    }

    this.unstick();
  }

  stick() {
    this.element.style.position = "sticky";
    this.element.style.top = `${this.offsetTop}px`;
  }

  unstick() {}
}
